export default {
  descricao: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/origem/components/search/search-form.js